import {ComponentType, ErrorInfo, FC, PropsWithChildren, useCallback, useState} from 'react'
import {FallbackProps, ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary'
import ErrorFallback from './ErrorFallback'

interface ErrorBoundaryProps extends PropsWithChildren {
  FallbackComponent?: ComponentType<FallbackProps>
}

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({
  children,
  FallbackComponent,
}: PropsWithChildren<ErrorBoundaryProps>) => {
  const [key, setKey] = useState(0)

  /**
   * Is called whenever an error is caught.
   * This prop can be used to log errors to an error reporting service.
   */
  const handleOnError = useCallback((error: Error, info: ErrorInfo) => {
    // Use your preferred error logging service
    console.error('Caught an error:', error, info)
  }, [])

  /**
   * Is called right before the error state is reset.
   * This function is useful for performing any cleanup or state reset
   * in your app that should happen before re-rendering after an error.
   */
  const handleOnReset = useCallback(() => {
    // clearIndexedDB();
    setKey(key + 1)
  }, [])

  return (
    <ReactErrorBoundary
      FallbackComponent={FallbackComponent ?? ErrorFallback}
      onError={handleOnError}
      onReset={handleOnReset}
      resetKeys={[key]}
    >
      {children}
    </ReactErrorBoundary>
  )
}
